// extracted by mini-css-extract-plugin
export default {"button":"Button_button__r+Fg6","label":"Button_label__bYxFl","icon":"Button_icon__dl+Mc","spinner":"Button_spinner__m2onh"};